<template>
  <div class='group'>
    <input class="md-input" :type="inputType" required v-on:input="$emit('input', $event.target.value)" :style="postStyle.inputBorder + postStyle.largeFontSize">
    <span class='highlight' :style="postStyle.focusLabelColor"></span>
    <span class='bar' :style="postStyle.barHeight + postStyle.focusLabelColor"></span>
    <label class="input-label" :style="postStyle.focusLabelColor + postStyle.largeFontSize + postStyle.smallFontSize">{{ placeHolder }}</label>
    <div class='warning' :style="postStyle.smallFontSize">{{ warningTxt }}</div>
  </div>
</template>

<script>
// <material-design-input
//   bar-height='2px'
//   focus-label-color='#1e88e5'
//   input-border='1px solid #494949'
//   place-holder='test'
//   large-font-size='50px'
//   small-font-size='38px'
//   v-model="textInput"
//   warning-txt=""/>

export default {
  name: 'MaterialDesignInput',
  props: ['placeHolder', 'inputBorder', 'focusLabelColor', 'barHeight', 'largeFontSize', 'smallFontSize', 'warningTxt', 'inputType'],
  data () {
    return {
      msg: 'MD Input'
    }
  },
  computed: {
    postStyle: function () {
      let postStyle = {
        inputBorder: '',
        focusLabelColor: '',
        barHeight: '',
        largeFontSize: '',
        smallFontSize: ''
      }
      if (this.inputBorder) {
        postStyle.inputBorder = '--inputBorder: ' + this.inputBorder + ';'
      }
      if (this.focusLabelColor) {
        postStyle.focusLabelColor = '--focusLabelColor:' + this.focusLabelColor + ';'
      }
      if (this.barHeight) {
        postStyle.barHeight = '--barHeight: ' + this.barHeight + ';'
      }
      if (this.largeFontSize) {
        postStyle.largeFontSize = '--largeFontSize: ' + this.largeFontSize + ';'
      }
      if (this.smallFontSize) {
        postStyle.smallFontSize = '--smallFontSize: ' + this.smallFontSize + ';'
      }
      return postStyle
    }
  }
}
</script>

<style>
:root {
  --inputBorder: 1px solid #494949;
  --focusLabelColor: #494949;
  --barHeight: 2px;
  --largeFontSize: medium;
  --smallFontSize: small;
}

.group {
  box-sizing: border-box;
  position: relative;
  width: 100%;
}
.md-input {
  box-sizing: border-box;
  font-size: var(--largeFontSize);
  font-weight: normal;
  padding-left: 5px;
  padding-top:1%;
  display: block;
  width: 100%;
  border: none;
  border-bottom: var(--inputBorder);
  min-height: 48px;
}
.md-input::-webkit-outer-spin-button,
.md-input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}
.md-input:focus {
  outline: none;
}
.input-label {
  color: #aaaaaa;
  font-size: var(--largeFontSize);
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 5px;
  top: 25%;
  transition: 0.2s ease all;
}
.md-input:focus ~ .input-label, .md-input:valid ~ .input-label {
  top: -65%;
  font-size: var(--smallFontSize);
  color: var(--focusLabelColor);
}
.bar {
  position: relative;
  display: block;
  width: 100%;
}
.bar:before, .bar:after {
  content: '';
  height:var(--barHeight);
  width:0;
  bottom:2;
  position:absolute;
  background:var(--focusLabelColor);
  transition:0.2s ease all;
}
.bar:before {
  left:50%;
}
.bar:after {
  right:50%;
}
.md-input:focus ~ .bar:before, .md-input:focus ~ .bar:after {
  width:50%;
}
.highlight {
  position: absolute;
  height: 60%;
  width: 10%;
  top: 25%;
  left: 0;
  pointer-events: none;
  opacity: 0.5;
}
.md-input:focus ~ .highlight {
  animation:inputHighlighter 0.3s ease;
}
.warning {
  display: block;
  position: absolute;
  left: 5px;
  margin-top: 1%;
  color: #b71c1c;
  font-size: var(--smallFontSize);
}
@keyframes inputHighlighter {
  from  { background:var(--focusLabelColor); }
  to    { width:0; background:transparent; }
}

@media (max-width: 768px) {
  .md-input::-webkit-outer-spin-button,
  .md-input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
  }
  .start-form {
    width: 80%;
    margin: auto;
  }
  .md-input {
    font-size: medium;
    font-weight: normal;
    padding-left: 5px;
    padding-top: 2%;
    padding-bottom: 2%;
    display: block;
    width: 100%;
    border: none;
    border-bottom: 1px solid #494949;
    height: 48px;
  }
  .input-label {
    color: #aaaaaa;
    font-size: 18px;
    font-weight: normal;
    position: absolute;
    pointer-events: none;
    left: 5px;
    top: 15px;
    transition: 0.2s ease all;
  }
  .md-input:focus ~ .input-label, .md-input:valid ~ .input-label {
    top: -25px;
    font-size: 16px;
    color: var(--focusLabelColor);
  }
  .bar:before, .bar:after {
    content: '';
    height:2px;
    width:0;
    bottom:0;
    position:absolute;
    background:var(--focusLabelColor);
    transition:0.2s ease all;
  }
  .warning {
    display: block;
    position: absolute;
    left: 5px;
    margin-top: 1%;
    color: #b71c1c;
    font-size: small;
  }
}
</style>
